"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectPackageInfo = void 0;

var _package2 = /*#__PURE__*/_interopRequireDefault( /*#__PURE__*/require("./package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable @typescript-eslint/ban-ts-comment, no-underscore-dangle */
// @ts-ignore
var collectPackageInfo = function collectPackageInfo(entityName) {
  if (typeof window === 'undefined') {
    return;
  }

  var name = _package2["default"].name,
      version = _package2["default"].version;

  if (!window.__PLASMA_INFO__) {
    window.__PLASMA_INFO__ = {};
  }

  if (!window.__PLASMA_INFO__[name]) {
    window.__PLASMA_INFO__[name] = {
      version: version,
      entities: [entityName]
    };
    return;
  }

  window.__PLASMA_INFO__[name].entities.push(entityName);
};

exports.collectPackageInfo = collectPackageInfo;